export default __webpack_public_path__ + "static/media/item_management.a1300acb.png";